var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#3AB44A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2008 12.4004C15.8753 12.4004 14.8008 13.4749 14.8008 14.8004V29.2004C14.8008 30.5259 15.8753 31.6004 17.2008 31.6004H26.8008C28.1263 31.6004 29.2008 30.5259 29.2008 29.2004V18.8974C29.2008 18.2609 28.9479 17.6505 28.4978 17.2004L24.4008 13.1033C23.9507 12.6532 23.3402 12.4004 22.7037 12.4004H17.2008ZM18.4008 22.0004C17.738 22.0004 17.2008 22.5376 17.2008 23.2004C17.2008 23.8631 17.738 24.4004 18.4008 24.4004H25.6008C26.2635 24.4004 26.8008 23.8631 26.8008 23.2004C26.8008 22.5376 26.2635 22.0004 25.6008 22.0004H18.4008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceActive);
export default __webpack_public_path__ + "static/media/invoice-active.a5c2b5fad971389cb0930aca031b9b15.svg";
export { ForwardRef as ReactComponent };